import PeriodicTable from "./Components/PerodicTable";


function App() {
  return (
    <div>
      <h1 className="text-center"><u>Periodic Table Explorer</u></h1>
      <PeriodicTable />
    </div>
  );
}

export default App;
